import OffersSection from "../../components/Offers/Offers";
import RentListings from "../../components/RentListings/RentListings";
import SellListings from "../../components/SellListing/SellListings";
import Slider from "../../components/Slider/Slider";
import { useGetSliderImagesQuery } from "../../store/slider/fetchSliderImages";

export default function Home() {
  const { data, isError, isLoading } = useGetSliderImagesQuery({});

  return (
    <main>
      <Slider
        images={data?.fields?.images?.arrayValue?.values}
        isLoading={isLoading}
        isError={isError}
      />
      <OffersSection />
      <SellListings />
      <RentListings />
    </main>
  );
}
